import { render, staticRenderFns } from "./CrmEmailEvent.vue?vue&type=template&id=c3cfe332"
import script from "./CrmEmailEvent.vue?vue&type=script&lang=ts"
export * from "./CrmEmailEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3cfe332')) {
      api.createRecord('c3cfe332', component.options)
    } else {
      api.reload('c3cfe332', component.options)
    }
    module.hot.accept("./CrmEmailEvent.vue?vue&type=template&id=c3cfe332", function () {
      api.rerender('c3cfe332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/events/CrmEmailEvent.vue"
export default component.exports